<template>
  <nav class="navbar min-w-1400">
    <div class="secondBox max-w-1400">
      <ul class="nav-links">
        <li
          :class="{
            'active-link': isActive('/') || $route.path === '/about_us',
          }"
          class="Li1"
        >
          <router-link to="/" class="nav-link1">
            <span class="routeText1">Quienes somos</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/develop' }" class="Li2">
          <router-link to="/develop" class="nav-link2">
            <span class="routeText2">Misión y visión</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/mission' }" class="Li3">
          <router-link to="/mission" class="nav-link2">
            <span class="routeText3">Desarrollo sostenible</span>
          </router-link>
        </li>
        <!-- <li :class="{ 'active-link': $route.path === '/protocol' }" class="Li4">
          <router-link to="/protocol" class="nav-link4">
            <span class="routeText4">Acuerdo de privacidad</span>
          </router-link>
        </li> -->
        <!-- <li
          :class="{
            'active-link': ['/about', '/protocol'].includes($route.path),
          }"
          class="Li4"
        >
          <router-link to="/about" class="nav-link4">
            <span class="routeText4">Sản Phẩm</span>
          </router-link>
        </li> -->
        <!-- <li :class="{ 'active-link': $route.path === '/protocol' }" class="Li5">
          <router-link to="/protocol" class="nav-link5">
            <span class="routeText5">Acuerdo de privacidad</span>
          </router-link>
        </li> -->
      </ul>
    </div>
    <div style="height: 130px"></div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      link1Color: "white",
    };
  },
  methods: {
    isActive(route) {
      return this.$route.path === route;
    },
  },
};
</script>
<style scoped>
.navbar {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  position: fixed; /* 将导航栏固定在页面上 */
  top: 0; /* 位于页面顶部 */
  z-index: 1000; /* 确保导航栏在其他元素上方 */
  margin-top: 80px;
}

.secondBox {
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 70px;
  padding: 0 35px;
  background-color: #ffffff;
}

.logo {
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
}

.logoImg {
  width: 170px;
  height: 40px;
  margin-top: 10px;
}

.title {
  width: 500px;
  height: 24px;
  font-size: 20px;
  font-family: SF Pro-Black Italic;
  font-weight: 600;
  color: #ffffff;
  line-height: 23px;
  padding-left: 17px;
  /* text-transform: uppercase; */
}

.routeText1,
.routeText2,
.routeText3,
.routeText4,
.routeText5 {
  font-size: 19px;
  font-family: SF Pro-Semibold;
  font-weight: 550;
  color: #333333;
  line-height: 29px;
  /* text-transform: uppercase; */
}

.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5 {
  text-decoration: none;
  margin: 0 auto;
  text-align: center;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  /* 垂直居中对齐 */
  justify-content: center;
  /* 水平居中对齐 */
  /* margin-left: 250px; */
}

.nav-links li {
  display: flex;
  padding: 8px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 45px;
  padding-left: 4px;
  padding-right: 4px;
  margin-left: 220px;
}
.Li1 {
  width: 180px;
}
.Li2 {
  width: 180px;
}
.Li3 {
  width: 240px;
}
.Li4 {
  width: 230px;
}
/* .Li5 {
  width: 250px;
} */
/* 这个如果给margin-right底部可能会出现边距的问题 */
/* .Li4 {
  width: 250px;
  
} */

.active-link .routeText1,
.active-link .routeText2,
.active-link .routeText3,
.active-link .routeText4,
.active-link .routeText5 {
  font-family: Inter-Extra Bold;

  color: #ff7a00;
}
</style>